import { Link01 } from '@ethsign/icons';
import classNames from 'classnames';

import { DotIcon } from '@/components';

import type { StatusType } from '@/types';

interface Props {
  status: StatusType;
  hasDot?: boolean;
}
export const statusToText = {
  wait_me: 'Pending Me',
  wait_other: 'Pending Others',
  completed: 'Completed',
  expired: 'Expired',
  link_active: 'Link Active',
  void: 'Voided'
};
const statusToDotColor = {
  wait_me: '#E29D70',
  wait_other: '#8A66A6',
  completed: '#12B76A',
  expired: '#475467',
  link_active: '#1570EF',
  void: '#F44336'
};
export function StatusTag(props: Props) {
  const { hasDot = true, status } = props;
  return (
    <span
      className={classNames('flex flex-row items-center h-[22px] rounded-2xl pl-[6px] pr-2 text-xs font-medium', {
        'bg-primary-25': status === 'wait_me',
        'bg-slime-50': status === 'completed',
        'bg-darkMatter-25': status === 'wait_other',
        'bg-gray-100': status === 'expired',
        'bg-blue-50': status === 'link_active',
        'text-primary-800': status === 'wait_me',
        'text-slime-700': status === 'completed',
        'text-darkMatter-500': status === 'wait_other',
        'text-gray-600': status === 'expired',
        'text-blue-600': status === 'link_active',
        'text-red-600': status === 'void',
        'bg-red-25': status === 'void'
      })}
    >
      {hasDot && (
        <span className="mr-[6px]">
          <DotIcon fill={statusToDotColor[status]}></DotIcon>
        </span>
      )}
      {status === 'link_active' && <Link01 className="mr-[2px]" size={16} color="#1570EF"></Link01>}
      {statusToText[status]}
    </span>
  );
}
